import { createStrictSchema } from '../../utils/morph.js';

const trustProfileInfoSchema = createStrictSchema({
    reputation: 'reputation',
    identity: 'identity',
    communication: 'communication',
    presence: 'presence',
    badges: 'badges',
    links: '_links',
    replyTimeText: 'replyTimeText',
});
const trustProfileSettingsSchema = createStrictSchema({
    externalUserId: 'externalUserId',
    enabled: 'allowPresenceDisplay',
});

export { trustProfileInfoSchema, trustProfileSettingsSchema };
//# sourceMappingURL=morph.js.map
